<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline :title="title">
      <span>Status: {{ formData.status }}</span>
      <a @click="$router.back()">
        <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back </v-btn>
        <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </a>
      <v-card-component>
        <div class="center">
          <v-row>
            <v-col cols="12" md="3">
              <v-autocomplete label="Request Type *" v-model="formData.requestType" readonly :items="requestTypes" key="id" item-value="id" item-text="value"> </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete readonly label="Reason *" v-model="formData.reason" :items="reasons" key="id" item-value="id" item-text="value"> </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field color="accent" label="From Date *" v-model="formData.fromDate" prepend-icon="mdi-calendar" readonly> </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field color="accent" label="To Date *" v-model="formData.toDate" prepend-icon="mdi-calendar" readonly> </v-text-field>
            </v-col>
            <!--Time Picker -->
            <v-col cols="12" md="3">
              <v-text-field color="accent" v-model="formData.clockIn" label="Clock In" prepend-icon="mdi-clock-time-four-outline" readonly v-bind="attrs" v-on="on"> </v-text-field>
            </v-col>
            <!--Time Picker end -->
            <!--Time Picker -->
            <v-col cols="12" md="3">
              <v-text-field color="accent" v-model="formData.clockOut" label="Clock Out" prepend-icon="mdi-clock-time-four-outline" readonly> </v-text-field>
            </v-col>
            <!--Time Picker end -->
            <v-col cols="12" md="3">
              <v-autocomplete readonly label="Break Time" v-model="formData.breakTime" :items="breakTimeOptions" key="id" item-value="id" item-text="value"> </v-autocomplete>
            </v-col>
          </v-row>

          <v-textarea outlined readonly color="accent" name="input-7-4" label="Message" v-model="formData.message"> </v-textarea>
          <!--File Attachments upload section start -->
          <h3>Attachments:</h3>
          <p class="text-center" v-if="formData.fileAttachments.length === 0">No Attachments uploaded</p>
          <v-row>
            <v-col v-for="(path, index) in formData.fileAttachments" :key="index" class="text-truncate relative" cols="2" md="2">
              <a :href="path.documentUrl" target="_blank">
                <v-icon>mdi-file-document-multiple-outline</v-icon>
                <span>{{ path.originalName }}</span>
              </a>
              <!-- <v-icon class="close-icon" @click="deleteFromFileBuffer(index)">
                mdi-close-box-outline
              </v-icon> -->
            </v-col>
          </v-row>
          <!--File attachment section ended -->
          <h3 v-if="formData.remark && formData.status === 'REJECTED'">Remark: {{ formData.remark }}</h3>
          <v-col>
            <div class="text-right">
              <v-btn @click="$router.back()" color="gray" class="px-2 ml-1 ma-1" min-width="0">
                <span class="ml-1">Cancel</span>
              </v-btn>
              <v-dialog v-if="formData.status === 'PENDING'" v-model="dialogReject" persistent max-width="290">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="red" v-bind="attrs" v-on="on" class="px-2 ml-1 ma-1" min-width="0">
                    <span class="ml-1 text-white">Reject</span>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="text-h5">
                    Rejection Reason
                  </v-card-title>
                  <v-card-text>
                    <v-textarea outlined color="accent" name="input-7-4" label="Message *" v-model="reason"> </v-textarea>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="gray"
                      @click="
                        dialogReject = false
                        reason = ''
                      "
                    >
                      Cancel
                    </v-btn>
                    <v-btn class="text-white" color="red" @click="rejectRequest()">
                      Confirm
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-btn v-if="formData.status === 'PENDING'" @click="approveRequest()" color="success" class="px-2 ml-1 ma-1" min-width="0">
                <span class="ml-1">Approve</span>
              </v-btn>
            </div>
          </v-col>
        </div>
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
// import CustomDatePicker from '@/components/template/CustomDatePicker'
import moment from 'moment'

export default {
  name: 'attendanceView',
  components: { VCardComponent, MaterialCard },
  props: ['id'],
  async created () {
    console.log(this.id)
    this.getAttendanceRequest()
    for (let i = 0; i < 121; i++) {
      this.breakTimeOptions.push({
        id: i,
        value: `${i} min`
      })
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      console.log(val.id)
    },
    academicYear: async function (val) {
      console.log(val.id)
    }
  },
  data () {
    return {
      modal1: false,
      modal2: false,
      menu2: false,
      dialogReject: false,
      reason: '',
      title: 'Attendance View',
      formData: {
        requestType: '',
        reason: '',
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        clockIn: '09:00',
        clockOut: '18:00',
        breakTime: 0,
        message: '',
        fileAttachments: [],
        status: '',
        remark: ''
      },
      breakTimeOptions: [],
      allowedFiles: ['pdf', 'pptx', 'docx', 'jpg', 'jpeg', 'png'],
      requestTypes: [],
      reasons: []
    }
  },
  methods: {
    async approveRequest () {
      try {
        this.$buefy.dialog.confirm({
          type: 'is-warning',
          title: 'Alert',
          hasIcon: true,
          message: 'Are you sure to approve this attendance request ?',
          onConfirm: async () => {
            try {
              let res = await http.put(`${constants.API_URL}/api/attendanceModule/changestatusattendanceleave/${this.id}`, {
                status: 'approved'
              })
              this.$buefy.dialog.confirm({
                type: 'is-success',
                title: 'Success',
                hasIcon: true,
                message: res.data,
                onConfirm: () => this.$router.push({ name: 'staffAttendance' }),
                canCancel: ['x']
              })
            } catch (e) {
              const errorMessage = (e && e.response && e.response.data.message) || e.message
              this.$buefy.toast.open({
                message: errorMessage,
                type: 'is-danger',
                duration: 4000
              })
            }
          }
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$buefy.toast.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    async rejectRequest () {
      try {
        if (!this.reason) {
          this.$buefy.toast.open({
            message: 'Reason is required!',
            type: 'is-danger',
            duration: 4000
          })
        } else {
          this.dialogReject = false

          let res = await http.put(`${constants.API_URL}/api/attendanceModule/changestatusattendanceleave/${this.id}`, {
            status: 'rejected',
            remark: this.reason
          })
          this.$buefy.dialog.confirm({
            type: 'is-success',
            title: 'Success',
            hasIcon: true,
            message: res.data,
            onConfirm: () => this.$router.push({ name: 'staffAttendance' }),
            canCancel: ['x']
          })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$buefy.toast.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    async getAttendanceRequest () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/attendanceModule/attendanceleave/${this.id}`)
        this.title = `${data.Name.user.firstName} ${data.Name.user.lastName}`
        this.requestTypes.push({
          id: '',
          value: data.type
        })
        this.reasons.push({
          id: '',
          value: data.reason
        })
        this.formData.status = data.status.trim()
        this.formData.remark = data.Log.remark
        this.formData.fromDate = data.fromDate
        this.formData.toDate = data.toDate
        this.formData.clockIn = data.clockInTime.toString().replace('00:', '')
        this.formData.clockOut = data.clockOutTime.toString().replace('00:', '')
        this.formData.breakTime = moment.duration(data.breakDuration).asMinutes()
        // data.breakDuration.toString().reverse().replace('00:', '').reverse().replace(':', '.')
        this.formData.message = data.message
        this.formData.fileAttachments = data.attachments
        console.log(this.formData)
      } catch (e) {
        console.log(e)
      }
    },
    async applyLeave () {
      try {
        console.log(this.formData)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error in fetching data : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          title: 'Failed to apply attendance',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    fromDateChange () {
      if (moment(this.formData.fromDate).isAfter(this.formData.toDate)) {
        this.formData.toDate = this.formData.fromDate
      }
    },
    onFilechange () {
      let r = this.formData.fileAttachments.filter((a, i) => {
        return this.allowedFiles.includes(a.name.split('.').pop())
      })
      this.formData.fileAttachments = r
      console.log(`File Length: ${this.formData.fileAttachments.length}`)
    },
    deleteFromFileBuffer (index) {
      let that = this
      this.$buefy.dialog.confirm({
        type: 'is-danger',
        title: 'Alert',
        hasIcon: true,
        message: 'Are you sure to delete the file ?',
        onConfirm: () => {
          that.formData.fileAttachments.splice(index, 1)
          console.log(`File Length: ${that.formData.fileAttachments.length}`)
        }
      })
    }
  }
}
</script>

<style scoped>
.text-white {
  color: #fff;
}
#status {
  text-align: right;
}
.center-hub {
  margin: auto;
  width: 60%;
  border: 5px solid #ffff00;
  padding: 10px;
}
.homework-description {
  border: solid rgb(223 179 196) 1px;
}
.left-auto {
  margin-left: 50%;
}
.relative {
  position: relative;
}
.close-icon {
  position: absolute;
  right: 0;
  top: 0;
}
.upload-title {
  font-weight: 600;
}
</style>
